module.exports = __webpack_public_path__ + "img/Noah_Kaufman.39c182eb.jpg";